import { CardsProps } from "@amzn/awsui-components-react";
import { LocalITOrderConfirmationContentProps } from "interfaces";
import StandardHardwareOrderConfirmation from "./StandardOrder/StandardOrder";
import NonStandardHardwareOrderConfirmation from "./NonstandardOrder/NonstandardOrder";

export const getStringPath: string = "common.component.LocalItOrderConfirmationContent";

/**
 * Renders the LocalITOrderConfirmation component.
 * Which represents both the standard and non standard order confirmation
 *
 * @returns {JSX.Element} An render of the selected order
 */
const LocalITOrderConfirmationContent = ({
    getHasError,
    standardOrder,
    setStandardOrder,
    isOrderStandard,
    nonStandardOrder,
    setNonStandardOrder,
}: LocalITOrderConfirmationContentProps) => {
    /* CARDS LAYOUT */
    const MAXIMUM_AMOUNT_OF_HORIZONTAL_CARDS: number = 1;
    const cardsLayout: CardsProps.CardsLayout[] = [{ cards: MAXIMUM_AMOUNT_OF_HORIZONTAL_CARDS }];

    if (isOrderStandard) {
        return (
            <StandardHardwareOrderConfirmation
                getHasError={getHasError}
                cardsLayout={cardsLayout}
                standardOrder={standardOrder}
                setStandardOrder={setStandardOrder}
            />
        );
    }

    return (
        <NonStandardHardwareOrderConfirmation
            getHasError={getHasError}
            cardsLayout={cardsLayout}
            nonStandardOrder={nonStandardOrder}
            setNonStandardOrder={setNonStandardOrder}
        />
    );
};

export default LocalITOrderConfirmationContent;
